import { DropZoneFile } from "app/components/file-upload/drop-zone/DropZone";
import { Helper, JobDto, JobRequestDto, SpecialAssessDto, SpecialAssessRequestDto, StatAssessDto, StatAssessRequestDto, UserProfileDto, UserHealthDto, UserHealthRequestDto, UserProfileRequestDto, AnnouncementRequestDto, IFormAnnouncement, AnnouncementDto, API_IMG_ANNOUNCE_FILE, AnnouncementFileDto, AnnouncementTypeEnum, SeasonDto, IFormSeason, SeasonRequestDto, SystemDateSaveFormat, RegisterDto, AnnounceQuestionDto, IFormQuestion, SystemTimeFormat } from "..";
import { IFormSelfAssessItem, IFormSelfAssess, IFormUserProfile, IFormSpecialAssess, IFormJobAssess, IFormStatAssess, IFormHealthProfile, IFormSelfAssessSetting } from "../models/Base";
import { SelfAssessDto, SelfAssessRequestDto, SelfAssessSettingRequestDto } from "../models/dto/SelfAssessment";
import { ResoveTimeZone } from "./Helper";
import moment from "moment";


export function mapFields() {

}

export function mapUserProfileDto(data: IFormUserProfile) {
    throw new Error('Function not implemented.');
}
export function mapSelfAsess(item: IFormSelfAssessItem, recordDate: Date, seasonId?: number): SelfAssessRequestDto {
    const d = Helper.ResoveTimeZone(recordDate)
    const result: SelfAssessRequestDto = {
        title: item.title,
        recordDate: d,
        point: !item.answer ? item.point : 0,
        seasonId: seasonId ?? 0,
        assessTypeId: 1,
        category: item.category
    }
    return result;
}


export function FormSelfAssess(model: SelfAssessDto[]) {
    const result: IFormSelfAssess = {
        items: FormSelfAssessItem(model)
    }
    return result;
}



export function FormSelfAssessSetting(data: SelfAssessDto) {
    const model: IFormSelfAssessSetting = {
        assessTypeId: 1,
        category: data.category,
        title: data.title,
        point: data.point
    }
    return model
}

export function mapSelfAssessSetting(data: IFormSelfAssessSetting) {
    const model: SelfAssessSettingRequestDto = {
        assessTypeId: 1,
        category: data.category,
        title: data.title,
        point: data.point
    };
    return model;
}


export function FormSelfAssessItem(model: SelfAssessDto[]) {
    const result: IFormSelfAssessItem[] = []
    model.map((item, index) => {
        result.push({
            title: item.title,
            answer: true,
            point: item.point,
            seasonId: item.seasonId,
            assessTypeId: item.assessTypeId,
            category: item.category
        })
    })
    return result;
}


export function FormSpecialAssess(item: SpecialAssessDto) {
    const model: IFormSpecialAssess = {
        title: item.title,
        point: item.point,
        seasonId: item.seasonId,
        assessTypeId: 2,
        file: item.file,
        recordDate: item.recordDate
    }
    return model;
}
export function mapSpecialAsess(item: IFormSpecialAssess) {
    const model: SpecialAssessRequestDto = {
        title: item.title,
        recordDate: item.recordDate,
        point: item.point,
        seasonId: item.seasonId,
        assessTypeId: 2,
        file: item.file
    }
    return model;
}


export function mapJobAsess(item: IFormJobAssess) {

    const sd = moment(item.recordDate).format(SystemDateSaveFormat) + ' ' + item.startTimeStr;
    const ed = moment(item.recordDate).format(SystemDateSaveFormat) + ' ' + item.endTimeStr;
    const model: JobRequestDto = {
        title: item.title,
        recordDate: ResoveTimeZone(new Date(item.recordDate)),
        point: item.point,
        seasonId: item.seasonId,
        assessTypeId: 3,
        jobCategory: item.jobCategory,
        startTime: moment(sd).valueOf(),
        endTime: moment(ed).valueOf(),
        totalHr: 0,
        startTimeStr: item.startTimeStr,
        endTimeStr: item.endTimeStr,
    }
    return model;
}
export function FormJobAssess(item: JobDto) {
    const sd = moment(item.recordDate).format(SystemDateSaveFormat) + ' ' + item.startTimeStr;
    const ed = moment(item.recordDate).format(SystemDateSaveFormat) + ' ' + item.endTimeStr;
    const model: IFormJobAssess = {
        seasonId: item.seasonId,
        assessTypeId: item.assessTypeId,
        title: item.title,
        point: item.point,
        recordDate: item.recordDate,
        jobCategory: item.jobCategory,
        startTime: moment(sd).valueOf(),
        endTime: moment(ed).valueOf(),
        totalHr: item.totalHr,
        startTimeStr: item.startTimeStr,
        endTimeStr: item.endTimeStr,
        testStartTime: "",
        testEndTime: ""
    }
    return model;
}


export function mapStatAsess(item: IFormStatAssess) {
    if (!item.recordDate)
        return;
    const d1 = new Date(item.recordDate)
    const d2 = new Date(d1.getFullYear(), d1.getMonth(), 1)
    const d = Helper.ResoveTimeZone(d2);
    const model: StatAssessRequestDto = {
        seasonId: item.seasonId,
        recordDate: d,
        numberOfCase: item.numberOfCase,
        income: item.income,
        workingHour: item.workingHour,
        numberOfVocation: item.numberOfVocation,
        workingPercentage: item.workingPercentage,
        workingDay: item.workingDay
    }
    return model;
}

export function FormStatAssess(item: StatAssessDto) {
    const model: IFormStatAssess = {
        seasonId: item.seasonId,
        recordDate: item.recordDate,
        numberOfCase: item.numberOfCase,
        income: item.income,
        workingHour: item.workingHour,
        numberOfVocation: 0,
        workingPercentage: item.workingPercentage,
        lastHr: 0,
        workingDay: item.workingDay,
    }
    return model;
}
export function mapUserProfile(item: IFormUserProfile) {
    const model: UserProfileRequestDto = {
        email: item.email ?? '',
        userId: item.userId,
        firstName: item.firstName,
        lastName: item.lastName,
        employeeId: item.employeeId,
        startWorkingDate: item.startWorkingDate ?? new Date(),
        workingTypeCode: item.workingTypeCode,
        affiliateCode: item.affiliateCode,
        roleCode: item.roleCode,
        avatar: item.avatar,
        isActive: item.isActive ?? false
    }
    return model;
}

export function FormUserProfile(item: UserProfileDto) {
    const model: IFormUserProfile = {
        userId: item.userId,
        firstName: item.firstName,
        lastName: item.lastName,
        employeeId: item.employeeId,
        startWorkingDate: item.startWorkingDate ?? new Date(),
        workingTypeCode: item.workingTypeCode,
        affiliateCode: item.affiliateCode,
        roleCode: item.roleCode,
        avatar: item.avatar,
        avatarTempUrl: item.avatar,
        isActive: item.isActive,
        email: item.email
    }
    return model;
}

export function FormUserHealth(item: UserHealthDto) {
    const model: IFormHealthProfile = {
        id: item.id,
        userProfileId: item.userProfileId,
        recordDate: item.recordDate,
        sexCode: item.sexCode,
        weight: item.weight,
        height: item.height,
        hb: item.hb,
        hct: item.hct,
        gluclose: item.gluclose,
        uricAcid: item.uricAcid,
        cholesterol: item.cholesterol,
        triglyceride: item.triglyceride,
        hdl: item.hdl,
        ldl: item.ldl,
        urine: item.urine,
        other: item.other
    }
    return model;
}

export function mapUserHealth(item: IFormHealthProfile) {
    const model: UserHealthRequestDto = {
        userProfileId: item.userProfileId,
        recordDate: Helper.ResoveTimeZone(new Date(item.recordDate)),
        sexCode: item.sexCode,
        weight: item.weight,
        height: item.height,
        hB: item.hb,
        hCT: item.hct,
        gluclose: item.gluclose,
        uricAcid: item.uricAcid,
        cholesterol: item.cholesterol,
        triglyceride: item.triglyceride,
        hDL: item.hdl,
        lDL: item.ldl,
        urine: item.urine,
        other: item.other
    }
    return model;
}


export function mapAnnouncement(item: IFormAnnouncement) {
    const model: AnnouncementRequestDto = {
        seasonId: item.seasonId,
        title: item.title,
        description: item.description,
        status: item.status,
        point: item.point,
        expiredDate: item.expiredDate,
        announcementFiles: mapAnnouncementFiles(item.announcementFiles),
        isActive: item.isActive,
        type: item.type,

        isRead: false,
        announceQuestions: item.announceQuestions
    }
    return model;
}

export function mapAnnouncementFiles(item: DropZoneFile[]) {
    const dbFile = item.filter(x => x.frmDb).map((x) => {
        return {
            fileName: x.fileName ?? "",
            originalFileName: x.fileName ?? "",
            isNew: false,
        }
    })
    return dbFile
}


export function FormAnnouncement(item: AnnouncementDto) {
    const announceAnswer = item.announceToAnswers?.[0] ?? {
        announceId: 0,
        seasonId: 0,
        userProfileId: '',
        answer: '',
        isRead: false,
        status: '',
    }
    const model: IFormAnnouncement = {
        id: item.id,
        seasonId: item.seasonId,
        title: item.title,
        description: item.description,
        status: announceAnswer.status,
        point: item.point,
        expiredDate: item.expiredDate,
        createdDate: item.createdDate,
        announcementFiles: FormAnnouncementFiles(item.announcementFiles),
        isActive: item.isActive,
        type: item.type,
        isRead: announceAnswer.isRead,
        isShowModel: false,
        announceQuestions: FormAnnounceQuestion(item.announceQuestions)
    }
    return model;
}

export function FormAnnounceQuestion(items: AnnounceQuestionDto[]) {
    const models: IFormQuestion[] = []
    items && items.map((item, index) => {
        return models.push({
            id: item.id,
            question: item.question,
            answer: item.answer
        })

    })
    return models;
}

export function FormAnnouncementFiles(item: AnnouncementFileDto[]) {
    const imgs: DropZoneFile[] = []
    item.forEach((img: any) => {
        imgs.push({
            src: `${API_IMG_ANNOUNCE_FILE}/` + img.fileName,
            fileName: img.fileName,
            frmDb: true,
        })
    })
    return imgs;
}

export function FormSeason(item: SeasonDto) {
    const model: IFormSeason = {
        title: item.title,
        periodStart: new Date(item.periodStart),
        periodEnd: new Date(item.periodEnd),
        status: item.status,
        expiredDate: new Date(item.expiredDate)
    }
    return model;

}
export function mapSeason(item: IFormSeason) {
    const model: SeasonRequestDto = {
        title: item.title,
        periodStart: Helper.ResoveTimeZone(item.periodStart),
        periodEnd: Helper.ResoveTimeZone(item.periodEnd),
        status: item.status,
        expiredDate: Helper.ResoveTimeZone(item.expiredDate)
    }
    return model;
}


export function mapUserRegiseter(item: IFormUserProfile) {
    const model: RegisterDto = {
        firstName: item.firstName,
        lastName: item.lastName,
        employeeId: item.employeeId,
        startWorkingDate: item.startWorkingDate ?? new Date(),
        workingTypeCode: item.workingTypeCode,
        affiliateCode: item.affiliateCode,
        roleCode: item.roleCode,
        userName: item.userName ?? "",
        password: item.password ?? "",
        avatar: "",
        isActive: false,
        email: item.email ?? ''
    }
    return model
}
